import React from 'react';
import Button from './Button';
import './ModalDiaNoHabil.css';

export interface ModalDiaNoHabilProps {
  visible: boolean;
  mensaje: string;
  onAceptar: () => void;
}

/**
 * Modal de aviso de día no hábil. Compartido por los flujos de pago
 * (facturas y recordatorios).
 */
const ModalDiaNoHabil: React.FC<ModalDiaNoHabilProps> = ({ visible, mensaje, onAceptar }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-dia-no-habil">
        <div className="modal-dia-no-habil__icono" aria-hidden="true">!</div>
        <p className="modal-dia-no-habil__aviso">Aviso</p>
        <p className="modal-dia-no-habil__mensaje">{mensaje}</p>
        <div className="modal-dia-no-habil__acciones">
          <Button onClick={onAceptar}>Aceptar</Button>
        </div>
      </div>
    </div>
  );
};

export default ModalDiaNoHabil;
